import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Typography from '@mui/material/Typography';

/** Render Campaign Hub page context in the shared workspace header. */
export default function CampaignHubPageHeader({ title, subtitle, action, meta }) {
  const [target, setTarget] = useState(null);
  useEffect(() => {
    if (typeof document !== 'undefined') setTarget(document.getElementById('campaign-hub-page-header'));
  }, []);
  if (!target) return null;

  return createPortal(
    <div className="flex min-w-0 flex-1 items-center justify-between gap-3">
      <div className="min-w-0">
        <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1">
          <Typography className="!truncate !text-base !font-extrabold !leading-tight" title={title}>{title}</Typography>
          {meta && <Typography className="!text-[11px] !leading-tight" color="text.secondary">{meta}</Typography>}
        </div>
        <Typography className="!truncate !text-xs !leading-tight" color="text.secondary" title={subtitle}>{subtitle}</Typography>
      </div>
      {action && <div className="flex shrink-0 items-center gap-2">{action}</div>}
    </div>,
    target,
  );
}
